import { reset_vars_css } from './vars.js';
import { global_vars } from './globalVars.js';
import { detect_browser } from './browser.js';

let ticking = false;
let resizeEndTimeout = null;
let oldY = 0;
let y = 0;

export function resizeCallback() {
    if (!ticking) {
        requestAnimationFrame(resizeUpdate);
        ticking = true;
    }
}

function resizeUpdate() {
    ticking = false;
    clearTimeout(resizeEndTimeout);

    resizeEndTimeout = setTimeout(() => {
        updateValues();
    }, 66);
}

function updateValues() {
    const { isSafari } = detect_browser();

    if (isSafari) {
        const diff = Math.abs(oldY - y);
        if (diff > 140) {
            reset_vars_css();
            global_vars();
        }
    } else {
        reset_vars_css();
        global_vars();
    }

    oldY = y;
}
